import {Button, FlexContainer, PH2Text, DescriptionText} from "../../../../design";
import VisaIcon from "../../../../assets/imgs/visa.png";
import MasterIcon from "../../../../assets/imgs/master.png";
import AmexIcon from "../../../../assets/imgs/ae.png";
import DiscoverIcon from "../../../../assets/imgs/discover.png";
import RupayIcon from "../../../../assets/imgs/rupay.png";
import React, { useState, useEffect } from "react";
import Support from "../../../../components/support";
import { Col, Row } from "react-awesome-styled-grid";
import getformatteddate from "../../../../utils/getformatteddate";
import currencyformatter from "../../../../utils/currencyformatter";
import { AmountDivideByHundred } from "../../../../helper";
import { INVOICE_LINK } from "../../../../appconstants";

type Props = {
  download: Function,
  account: Object,
  history: {
    push: Function,
  },
  email: string,
  phone: string,
  status: string
}

const DownLoadInvoice = (props:Props) => {
  const {
    download, 
    history, 
    phone, 
    email, 
    status, 
    account, 
    partialPaymentDetails, 
    currency,
  } = props;
  const {location: { pathname, search }} = history;
  const params = new URLSearchParams(search);
  const [enablePayment, setEnablePayment] = useState(true);

  useEffect(() => {
    if (!partialPaymentDetails) return;
    setEnablePayment(false);
  }, [partialPaymentDetails]);

  return(
    <div className="mt-5 text-center h-100 position-relative">
      {partialPaymentDetails && currency &&
        <Col>
          <Row className="p-2" style={{ backgroundColor: "#EEEEFF" }}>
            <PH2Text fontWeight="bold" className="text-center">
              Payment Terms
            </PH2Text>
          </Row>
          <Row>
            <Col>
              <Col>
                <DescriptionText>Initial Amount:</DescriptionText>
                <DescriptionText color="#000000" fontWeight="400">
                  {partialPaymentDetails?.initialAmount? currencyformatter(AmountDivideByHundred(partialPaymentDetails?.initialAmount), currency.name) : "N.A."}
                </DescriptionText>
              </Col>
              <Col>
                <DescriptionText>Due Date:</DescriptionText>
                <DescriptionText color="#000000" fontWeight="400">
                  {partialPaymentDetails?.dueDate? getformatteddate(partialPaymentDetails?.dueDate,  account && account.timezone) : "N.A."}
                </DescriptionText>
              </Col>
            </Col>
            <Col>
              <Col>
              <DescriptionText>Pending Amount:</DescriptionText>
                <DescriptionText color="#000000" fontWeight="400">
                  {partialPaymentDetails?.pendingAmount? currencyformatter(AmountDivideByHundred(partialPaymentDetails?.pendingAmount), currency.name) : "N.A."}
                </DescriptionText>
              </Col>
              <Col>
                <DescriptionText>Late Fee:</DescriptionText>
                <DescriptionText color="#000000" fontWeight="400">
                  {partialPaymentDetails?.lateFee? currencyformatter(AmountDivideByHundred(partialPaymentDetails?.lateFee), currency.name) : "N.A."}
                </DescriptionText>
              </Col>
            </Col>
            <Col>
              <Col>
                <DescriptionText>Interest if Overdue:</DescriptionText>
                <DescriptionText color="#000000" fontWeight="400">
                  {partialPaymentDetails?.overdueInterest? `${partialPaymentDetails?.overdueInterest}%` : "N.A."}
                </DescriptionText>
              </Col>
            </Col>
          </Row>
        </Col>
      }
      <div className="text-center mt-5">
        { status &&  
          (
            <>
              {partialPaymentDetails
                  && !(status === "PAID" || status === "CANCELLED" || status === "REFUNDED" || status === "EXPIRED" || status === "PARTIALLY_REFUNDED" || params.get('InvoiceDownload') === 'true')
                  &&
                <FlexContainer
                  display="flex"
                  flexWrap="nowrap"
                  className="mb-4 ml-2 mt-4"
                  alignItems="center"
                >
                  <input 
                    id="partialPaymentTermsAndConditionAcceptance" 
                    type="checkbox"
                    className="m-2 h-4"
                    onChange={e => setEnablePayment(e.target.checked)}
                  />
                  <label 
                    forHtml="partialPaymentTermsAndConditionAcceptance"
                    className="text-center"
                  >
                    {INVOICE_LINK.PAY_TERMS}
                  </label>
                </FlexContainer>
              }
              <Button 
                onClick={download}
                hidden={status === "ACTIVE"}
                type="secondary" 
                border="1px solid #40a9ff !important" 
                borderRadius="50px" 
                className="px-4 py-2 mb-4"
              >
                  {account && account.organisationType === "NON_PROFIT" ? "Download Receipt" : "Download Invoice"}
              </Button>
              <br/>
              <Button 
                hidden={status === "PAID" || status === "CANCELLED" || status === "REFUNDED" || status === "EXPIRED" || status === "PARTIALLY_REFUNDED" || params.get('InvoiceDownload') === 'true'}
                onClick={() => enablePayment? props.history.push(`${pathname}/pay`) : null}
                type="primary" 
                border="1px solid #40a9ff !important" 
                borderRadius="50px" 
                className="px-5 py-2"
                disabled={!enablePayment}
              >
                {account && account.organisationType === "NON_PROFIT" ? "DONATE NOW" : "PAY NOW"}
              </Button>
            </>
          )
        }
        {/* <div className="mt-4 bg-white"> */}
        {!(status === "PAID" || status === "CANCELLED" || status === "REFUNDED" || status === "EXPIRED" || status === "PARTIALLY_REFUNDED" || params.get('InvoiceDownload') === 'true')
            &&
            <FlexContainer
            display="flex"
            borderRadius="3px"
            boxShadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
            className="text-center p-3 mx-1 mt-4 bg-white"
            flexDirection="row"
            flexWrap="nowrap"
            justifyContent="center"
            alignItems="center"
        >
          <img src={VisaIcon} height="20px" className="pr-4" alt={''}/>
          <img src={MasterIcon} height="20px" className="pr-4" alt={''}/>
          <img src={AmexIcon} height="20px" className="pr-4" alt={''}/>
          <img src={DiscoverIcon} height="20px" className="pr-4" alt={''}/>
          <img src={RupayIcon} height="20px" alt={''}/>
        </FlexContainer>}
        {/* </div> */}
      </div>
      <div 
        className="mt-5 text-left" 
        style={{bottom: "5%", position: "absolute"}}
      >
        <Support email={email} phone={phone}/>
      </div>
    </div>
  )
};

export default DownLoadInvoice
